// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2aVs2","subheader":"ReorderModal_subheader__4tp07","listWrap":"ReorderModal_listWrap__l2jnh"};